import { GraphqlMutableStoreBase } from "../GraphqlMutableStoreBase";
import gql from "graphql-tag";
const sensorConfigurationFragments = gql `
  fragment SensorConfigurationStoreFields on SensorConfiguration {
    id
    name
    streamName
  }
`;
const sensorConfigurationsStoreDocument = gql `
  ${sensorConfigurationFragments}
  query SensorConfigurationsStore {
    getSensorConfigurations {
      ...SensorConfigurationStoreFields
    }
  }
`;
const updateSensorConfigurationStoreDocument = gql `
  ${sensorConfigurationFragments}
  mutation UpdateSensorConfigurationStore($SensorConfiguration: SensorConfigurationUpdateInput!) {
    updateSensorConfiguration(sensorConfiguration: $SensorConfiguration) {
      ...SensorConfigurationStoreFields
    }
  }
`;
export class SensorConfigurationStore extends GraphqlMutableStoreBase {
    constructor(authStore, apolloClient) {
        super("SensorConfiguration", authStore, apolloClient, 
        // Mutation
        updateSensorConfigurationStoreDocument, (item) => {
            return { SensorConfiguration: item };
        }, 
        // Query
        sensorConfigurationsStoreDocument, (queryData) => {
            return queryData.getSensorConfigurations;
        });
    }
}
//# sourceMappingURL=index.js.map